import { useCallback, useState } from 'react';

/** Creator-table page offset that falls back to the first page whenever `rangeKey` changes. */
export function useCreatorOffset(rangeKey: string): [number, (offset: number) => void] {
  const [state, setState] = useState({ rangeKey, offset: 0 });
  if (state.rangeKey !== rangeKey) setState({ rangeKey, offset: 0 });
  const offset = state.rangeKey === rangeKey ? state.offset : 0;
  const setOffset = useCallback(
    (next: number) =>
      setState((prev) => (prev.rangeKey === rangeKey && prev.offset === next ? prev : { rangeKey, offset: next })),
    [rangeKey],
  );
  return [offset, setOffset];
}
